export type Opacity = keyof typeof OPACITY;
export const OPACITY = {
    primary: 1,
    secondary: 0.64,
    disabled: 0.32,
} as const;
